<template>
  <div class="pagesContent">
    <el-container>
      <el-header style="height: 60px">
        <div class="header-title">
          <h4 ref='aaa'>批量录入员工信息</h4>
        </div>
      </el-header>
      <el-main class="main-box">
        <el-card>
            <el-table :data="staffInfo" style="width: 100%">
              <el-table-column label="工号(必填)" align="center" width="160" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.JobNumber}}</div>
                  <el-form v-else :model="scope.row" autocomplete="off" :ref="'FormJob'+ scope.$index" :rules="AddRules" class="formbox">
                    <el-form-item prop="JobNumber" class="formitem">
                        <el-input v-model="scope.row.JobNumber" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入员工工号" size="small"></el-input> <!-- @input="judgeStaffJobNumber(scope.$index, scope.row)" -->
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column label="姓名" align="center" width="160" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.Name}}</div>
                  <el-input v-else v-model="scope.row.Name" placeholder="请输入员工姓名" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="性别" align="center" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">
                    <span v-if="scope.row.Sex == 1">男</span>
                    <span v-else>女</span>
                  </div>
                  <el-select v-else v-model="scope.row.Sex" size="small">
                    <el-option label="男" :value="1"></el-option>
                    <el-option label="女" :value="2"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="联系电话" align="center" width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.Phone}}</div>
                  <el-input v-else v-model="scope.row.Phone" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入员工联系电话" size="small" maxlength="11"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="身份证号" align="center" width="260">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.IDNumber}}</div>
                 <el-input v-else v-model="scope.row.IDNumber" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入员工身份证号" size="small" maxlength="18"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="籍贯" align="center" width="260">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.NativePlace}}</div>
                  <el-input v-else v-model="scope.row.NativePlace" placeholder="请输入员工籍贯" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="现居住地" align="center" width="300">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.CurrentResidence}}</div>
                  <el-input v-else v-model="scope.row.CurrentResidence" placeholder="请输入员工现居住地" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="毕业院校" align="center" width="260">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.AlmaMater}}</div>
                  <el-input v-else v-model="scope.row.AlmaMater" placeholder="请输入员工毕业院校" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="学历" align="center" width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.Degree}}</div>
                  <el-input v-else v-model="scope.row.Degree" placeholder="请输入员工学历" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="专业" align="center" width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.Specialty}}</div>
                  <el-input v-else v-model="scope.row.Specialty" placeholder="请输入员工专业" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="登录账号" align="center" width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.UserName}}</div>
                  <el-form v-else :model="scope.row" autocomplete="off" :ref="'FormUser'+ scope.$index" class="formbox">
                    <el-form-item prop="UserName" class="formitem">
                        <el-input v-model="scope.row.UserName" placeholder="请输入员工登录账号" size="small"></el-input>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column label="登录密码" align="center" width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">{{scope.row.Password}}</div>
                  <el-input v-else v-model="scope.row.Password" placeholder="请输入员工登录密码" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="员工状态" align="center" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">
                    <span v-if="scope.row.Flag == 1">在职</span>
                    <span v-else>离职</span>
                  </div>
                  <el-select v-else v-model="scope.row.Flag" placeholder="请选择员工状态" size="small" @change="changeFlag(scope.$index,scope.row)">
                    <el-option label="在职" :value="1"></el-option>
                    <el-option label="离职" :value="2"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="入职时间" align="center" width="230">
                <template slot-scope="scope">
                  <div v-if="scope.row.permit">
                    <span v-if="scope.row.JoinTime != null">{{scope.row.JoinTime | dateYMDFormat }}</span>
                  </div>
                  <el-date-picker v-else
                      type="date"
                      v-model="scope.row.JoinTime"
                      placeholder="请选择员工入职时间"
                      size="small"
                      value-format="yyyy-MM-dd">
                  </el-date-picker>
                </template>
              </el-table-column>
              <!-- 离职时间 （当前行 职位状态为离职时，显示此项） -->
              <el-table-column label="离职时间" align="center" width="230">
                <template slot-scope="scope">
                  <span v-if="scope.row.Flag == 2">
                    <el-date-picker
                        v-if=" !scope.row.permit"
                        type="date"
                        v-model="scope.row.QuitTime"
                        placeholder="请选择员工离职时间"
                        size="small"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <div v-else>
                      <span v-if="scope.row.QuitTime != null">{{scope.row.QuitTime | dateYMDFormat }}</span>
                    </div>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" v-if="!scope.row.permit" @click="Permit(scope.$index,scope.row)">确认</el-button>
                  <el-button type="text" v-else @click="Cancel(scope.$index,scope.row)">取消</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 提交 -->
            <div class="submit-box">
              <div class="line"></div>
              <el-button type="primary" @click="submitAdd(staffInfo)"> 提交 </el-button>
              <el-button type="primary" plain @click="backstaffList"> 返回 </el-button>
            </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  export default{
    data(){
      //表单 自定义规则
      //判断员工工号是否存在
      var validateJobNumber = (rule, value, callback) => {
          var jobNumber = value
          if(jobNumber != ''){
            let job = '?jobNumber=' + jobNumber
            this.$http.judgeStaffJobNumber(job).then(res=>{
              // 布尔值:  true 工号存在 ；false 不存在
              if(res.data){  //不通过
                callback(new Error('工号已存在,请重新输入！'))
              }else{ //通过
                callback()
              }
            })
          }
        }
      //判断登录账号是否存在
      var validateUserName = (rule, value, callback) => {
          var UserName = value
          if(UserName != ''){
            // 特殊字符编码
            var Uname = encodeURIComponent(UserName)
            let user = '?userName=' + Uname
            this.$http.judgeStaffUserName(user).then(res=>{
              // console.log(res.data)
              // 布尔值:  true 登录账号存在 ；false 不存在
              if(res.data){  //不通过
                callback(new Error('登录账号已存在,请重新输入！'))
              }else{ //通过
                callback()
              }
            })
          }
        }
      return{
        //员工信息
        staffInfo:[
            {
              Name: '',  //员工姓名
              Sex: 1,  //性别   0未知  1男  2女
              IDNumber: '',  //身份证号
              JobNumber: '',  //员工工号
              UserName: '',  //系统账号
              Password: '',  //系统密码
              Flag: 1,  //0 未知 1 在职   2 离职  3 删除
              Phone:'',  //联系电话
              NativePlace: '',   //籍贯
              CurrentResidence: '',   //现居住地
              AlmaMater: '',   //毕业院校
              Degree: '',   //学历
              Specialty: '',   //专业
              JoinTime: null, //入职时间
              QuitTime:null, //离职时间 （状态为离职时，显示此项）
              permit: false
            },{
              Name: '',
              Sex: 1,
              IDNumber: '',
              JobNumber: '',
              UserName: '',
              Password: '',
              Flag: 1,
              Phone:'',
              NativePlace: '',
              CurrentResidence: '',
              AlmaMater: '',
              Degree: '',
              Specialty: '',
              JoinTime: null,
              QuitTime: null,
              permit: false
            },{
              Name: '',
              Sex: 1,
              IDNumber: '',
              JobNumber: '',
              UserName: '',
              Password: '',
              Flag: 1,
              Phone:'',
              NativePlace: '',
              CurrentResidence: '',
              AlmaMater: '',
              Degree: '',
              Specialty: '',
              JoinTime: null,
              QuitTime: null,
              permit: false
            },{
              Name: '',
              Sex: 1,
              IDNumber: '',
              JobNumber: '',
              UserName: '',
              Password: '',
              Flag: 1,
              Phone:'',
              NativePlace: '',
              CurrentResidence: '',
              AlmaMater: '',
              Degree: '',
              Specialty: '',
              JoinTime: null,
              QuitTime: null,
              permit: false
            },{
              Name: '',
              Sex: 1,
              IDNumber: '',
              JobNumber: '',
              UserName: '',
              Password: '',
              Flag: 1,
              Phone:'',
              NativePlace: '',
              CurrentResidence: '',
              AlmaMater: '',
              Degree: '',
              Specialty: '',
              JoinTime: null,
              QuitTime: null,
              permit: false
            }
          ],
        //表单验证规则 添加
        AddRules: {
          JobNumber: [{ required: true, message: '请输入员工工号', trigger: 'blur' },
                      { validator: validateJobNumber, trigger: 'blur' }],
        },
        //确认添加的数组
        newstaffInfo:[]
      }
    },
    methods:{
      //改变员工职位状态（在职，则清空离职时间）
      changeFlag(index,row){
        var rowFlag = row.Flag
        if(rowFlag == 1){
          this.staffInfo[index].QuitTime = null
        }
      },
      //添加取消
      Cancel(index,row){
        // console.log("取消行索引" + index)
        //状态还原，删除取消项
        this.staffInfo[index].permit = false
        var newstaffInfo = this.newstaffInfo
        for(var i = 0; i < newstaffInfo.length; i++){
          var rowIndex = newstaffInfo[i].rowIndex
          if(index == rowIndex){  //选中行 与 每项的行数 作对比 ，相同则去除此项
            let d = [index];
            // console.log(d)
            var spliceArr = newstaffInfo.filter(item => { return !d.includes(item.rowIndex); })
            this.newstaffInfo = spliceArr
            // console.log(this.newstaffInfo)
          }
        }
      },
      //添加确认
      Permit(index,row){
        // console.log("当前行索引" + index)
        //验证工号
        var FormJob = 'FormJob' + index
        this.$refs[FormJob].validate((valid) =>{
          if(valid){
            if(row.UserName != ''){//验证登录账号
              var FormUser = 'FormUser' + index
              this.$refs[FormUser].validate((valid) =>{
                if(valid){
                  //改变状态，push 新数组
                  this.staffInfo[index].permit = true
                  var obj = {
                    rowIndex: index,
                    row: this.staffInfo[index]
                  }
                  this.newstaffInfo.push(obj)
                  // console.log( this.newstaffInfo)
                }else{
                  this.$message.error({
                     message: '请检查当前行登录账号'
                  })
                }
              })
            }else{
              //改变状态，push 新数组
              this.staffInfo[index].permit = true
              var obj = {
                rowIndex: index,
                row: this.staffInfo[index]
              }
              this.newstaffInfo.push(obj)
              // console.log(this.newstaffInfo)
            }
          }else{
              this.$message.error({
                 message: '请检查当前行员工工号'
              })
          }
        })
      },
      //批量添加
      submitAdd(val){
        console.log(this.newstaffInfo)
        var newstaffInfo = this.newstaffInfo
        if(this.newstaffInfo.length > 0){
          // console.log("数组查重")
          // 遍历数组 工号、登录账号 push新数组
          var staffJob = []
          var staffUser = []
          newstaffInfo.map(function(item,index,newstaffInfo){
              // console.log(item)
              var JobNumber = item.row.JobNumber
              var UserName = item.row.UserName
                staffJob.push(JobNumber)
                staffUser.push(UserName)
          })
          // console.log(staffJob)
          // console.log(staffUser)
          //查找重复工号
          let repJob = [];
          staffJob.forEach((item,index)=>{
          	if(staffJob.indexOf(item)!=index){ // 匹配数组元素第一个item位置和当前循环的index
                let obj = {};
                obj.key = (staffJob.indexOf(item) + 1) + '|' + (index + 1); // 用'|'分隔两个重复项的下标
                obj.value = item;
                repJob.push(obj);
          	}
          });
          // console.log(repJob);
          //查找重复员工账号
          // let repUser = [];
          // staffUser.forEach((item,index)=>{
          // 	if(staffUser.indexOf(item)!=index){ // 匹配数组元素第一个item位置和当前循环的index
          //       let obj = {};
          //       obj.key = (staffUser.indexOf(item) + 1) + '|' + (index + 1); // 用'|'分隔两个重复项的下标
          //       obj.value = item;
          //       repUser.push(obj);
          // 	}
          // });
          // console.log(repUser);

          //判断完毕：消息提示 或者 提交数据
          if(repJob.length == 0){  //不重复 提交后台
            // console.log("========= 去重 提交 后台 =========")
            // console.log(newstaffInfo)
            //删除 无用字段 rowIndex permit
            // arr.map(item=>({row:item.row}))
            var spliceNewStaff = newstaffInfo.map(item=>{
              row: item.row,
              delete item.row.permit
              return {row: item.row}
            })
            // console.log(spliceNewStaff)
            var submitNewStaff = []
            spliceNewStaff.map(item=>{
               submitNewStaff.push(item.row)
            })
            // console.log(submitNewStaff)
            //提交
            this.$http.batchaddStaffInfo(submitNewStaff).then(res=>{
              // console.log(res)
              if(res.data.Code == 200){
                this.$message.success({
                  message: '批量添加成功'
                })
                //返回上一层
                this.$router.go(-1);

              }else if(re.data.Code == 100){
                this.$message.error({
                  message: '添加失败'
                })
              }
            })

          }
					// else{  //有重复，逐个排除
     //        if(repJob.length > 0 && repUser.length > 0){
     //          this.$message.error({
     //            message:'员工工号、登录账号均有重复，请更改后提交！'
     //          })
     //        }else{
     //          if(repJob.length > 0){
     //            this.$message.error({
     //              message:'员工工号重复，请更改后提交！'
     //            })
     //          }else{
     //            this.$message.error({
     //              message:'登录账号重复，请更改后提交！'
     //            })
     //          }
     //        }
     //      }
        }else{  //一条都没有
          this.$message.warning({
            message: '请至少确认添加一条信息！'
          })
        }
      },
      // 返回员工列表
      backstaffList(){
        this.$router.go(-1);//返回上一层
      },
    }
  }
</script>

<style>
  /* 主体盒子 */
  .main-box{
    background-color: #FFFFFF;
  }
  /* 添加按钮 */
  .submit-box{
    width: 100%;
    height: 120px;
    box-sizing: border-box;
    padding: 40px 0 40px 0;
    text-align: center;
  }
  .line{
    margin-bottom: 20px;
    border-top: 1px solid #dcdfe6;
  }
  /* 单条表单 上下居中*/
  .formitem{
    box-sizing: border-box;
    height: 74px;
    line-height: 74px;
    display: table-cell;
    vertical-align: middle;
  }
</style>
